import { PublishActions } from '@/api/api';
import getActionRequestBody from './normalizer/getActionRequestBody';

function submitAction({ action, data, packageName }) {
  const actionsAPIs = {
    publish_request: PublishActions.publishRequest,
    cancel_publish_request: PublishActions.cancelPublishRequest,
    warning_removal_request: PublishActions.warningRemovalRequest,
    cancel_warning_removal_request: PublishActions.cancelWarningRemovalRequest,
    publish: PublishActions.publish,
    unpublish: PublishActions.unpublish,
    autopublish: PublishActions.updatePublishRequest,
    cancel_autopublish: PublishActions.updatePublishRequest,
    hide: PublishActions.hide,
    suspension_removal_request: PublishActions.suspensionRemovalRequest,
    cancel_suspension_removal_request:
      PublishActions.cancelSuspensionRemovalRequest,
  };

  const requestBody = getActionRequestBody({ action, ...data });
  const apiCall = actionsAPIs[action];
  return apiCall({ packageName }, requestBody)
    .then(({ body }) => body)
    .catch(({ body }) => body);
}

export default { submitAction };
